export enum FactorScore {
    STRONG_POSITIVE = 'strong_positive',
    POSITIVE = 'positive',
    NEUTRAL = 'neutral',
    NEGATIVE = 'negative',
    STRONG_NEGATIVE = 'strong_negative',
    NONE = 'none',
}

export const getFactorScore = (value?: number): FactorScore => {
    if (typeof value === 'undefined') {
        return FactorScore.NONE;
    }
    if (value >= 76) {
        return FactorScore.STRONG_POSITIVE;
    }
    if (value >= 51) {
        return FactorScore.POSITIVE;
    }
    if (value >= 26) {
        return FactorScore.NEUTRAL;
    }
    if (value >= 1) {
        return FactorScore.NEGATIVE;
    }
    return FactorScore.STRONG_NEGATIVE;
};
